import SelectDepartment from './SelectDepartment'

export default SelectDepartment